import { BookOpen, type LucideIcon, Users } from 'lucide-react';

export interface SidebarItem {
  title: string;
  url?: string;
  icon: LucideIcon;
  isActive?: boolean;
  items?: {
    title: string;
    url: string;
  }[];
  roles?: string[];
}
const sidebarData: SidebarItem[] = [
  {
    title: 'Courses',
    icon: BookOpen,
    url: '/courses',
    roles: ['super_admin', 'admin'],
  },
  {
    title: 'Instructors',
    icon: Users,
    url: '/instructors',
    roles: ['super_admin', 'admin'],
  },
];

export default sidebarData;
